
import { useState } from "react";
import RealtimeTable from "./components/RealtimeTable";
//import ConfigTags from "./components/ConfigTags";
//import TagsGrid from "./components/TagsGrid_Glide";
//import TagsGrid from "./components/TagsGrid_TanStack";
import EditableDarkTable from "./components/EditableDarkTable";
import ConfigPLCs from "./components/ConfigPLCs";
import FavoriteCards from "./components/FavoriteCards";
import RealtimeCards from "./components/RealtimeCards";

export default function App() {
  const [selected, setSelected] = useState("table");
  const [menuOpen, setMenuOpen] = useState(false);

  const renderComponent = () => {
    switch (selected) {
      case "table":
        return <RealtimeTable />;
      case "tags":
        return <EditableDarkTable  />;
      case "plcs":
        return <ConfigPLCs />;
      case "cards":
        return <RealtimeCards />;
      case "fav":
        return <FavoriteCards />;
      default:
        return <RealtimeTable />;
    }
  };

  return (
    <div className="flex flex-col h-screen bg-gray-900 text-white">
      {/* Topbar */}
      <div className="flex items-center justify-between p-4 bg-gray-800 shadow-md">
        <h1 className="text-lg font-bold">📡 Monitoramento</h1>
        <button
          className="md:hidden text-white text-xl"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>
      </div>

      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <div
          className={`bg-gray-800 w-64 p-4 space-y-2 md:block ${
            menuOpen ? "block" : "hidden"
          }`}
        >
          <button
            className={`w-full text-left px-4 py-2 rounded ${
              selected === "table" ? "bg-blue-700" : "hover:bg-gray-700"
            }`}
            onClick={() => {
              setSelected("table");
              setMenuOpen(false);
            }}
          >
            📋 Visualizar Tabela
          </button>
          <button
            className={`w-full text-left px-4 py-2 rounded ${
              selected === "cards" ? "bg-blue-700" : "hover:bg-gray-700"
            }`}
            onClick={() => {
              setSelected("cards");
              setMenuOpen(false);
            }}
          >
            📦 Visualizar Cards
          </button>
          <button
            className={`w-full text-left px-4 py-2 rounded ${
              selected === "fav" ? "bg-blue-700" : "hover:bg-gray-700"
            }`}
            onClick={() => {
              setSelected("fav");
              setMenuOpen(false);
            }}
          >
            ⭐ Favoritos
          </button>
          <button
            className={`w-full text-left px-4 py-2 rounded ${
              selected === "tags" ? "bg-blue-700" : "hover:bg-gray-700"
            }`}
            onClick={() => {
              setSelected("tags");
              setMenuOpen(false);
            }}
          >
            ⚙️ Configurar Tags
          </button>
          <button
            className={`w-full text-left px-4 py-2 rounded ${
              selected === "plcs" ? "bg-blue-700" : "hover:bg-gray-700"
            }`}
            onClick={() => {
              setSelected("plcs");
              setMenuOpen(false);
            }}
          >
            🧠 Configurar PLCs
          </button>
        </div>

        {/* Main content */}
        <main className="flex-1 overflow-auto">{renderComponent()}</main>
      </div>
    </div>
  );
}
